import { Product } from "@repo/apis/browse-search-v2";
import { getStockPriceData } from "@repo/apis/stockprice";
import { getSummaries } from "@repo/apis/summaries";
import { ChameleonRequest } from "@repo/chameleon-request";
import { configurePageRouterServerRequest } from "@/utils/request-adapters/page-router-server-request";

type ProductsParams = {
  productsIdentifiers: number[];
  store: string;
  keyStoreDataversion: string;
  country: string;
  lang: string;
  shop: string;
  currency: string;
  sizeSchema: string;
  requestInstance: ReturnType<typeof configurePageRouterServerRequest>;
};

export const fetchProductsData = async (
  params: ProductsParams,
): Promise<Product[]> => {
  const {
    productsIdentifiers,
    store,
    keyStoreDataversion,
    country,
    lang,
    shop,
    currency,
    sizeSchema,
    requestInstance,
  } = params;

  try {
    const [stockDataResponse, summariesResponse] = await Promise.all([
      getStockPriceData({
        requestInstance: requestInstance as ChameleonRequest,
        productIds: productsIdentifiers,
        store,
        keyStoreDataversion,
        country,
        lang,
        shop,
      }),
      getSummaries({
        chameleonRequestInstance: requestInstance as ChameleonRequest,
        productIds: productsIdentifiers,
        store,
        keyStoreDataversion,
        lang,
        shop,
        currency,
        sizeSchema,
        expand: ["variants"],
      }),
    ]);

    const stockLookup = Object.fromEntries(
      stockDataResponse.map((item) => [item.productId, item]),
    );
    const summariesLookup = Object.fromEntries(
      summariesResponse!.map((item) => [item.id, item]),
    );

    const combinedData = productsIdentifiers
      .filter((id) => stockLookup[id] && summariesLookup[id])
      .map((id) => ({
        ...stockLookup[id],
        ...summariesLookup[id],
      }));
    return combinedData as unknown as Product[];
  } catch (error) {
    console.error("Error fetching stock data:", error);
    return [];
  }
};
